import { Text, View } from '@react-pdf/renderer';

import styles from './Styles';

export const AdditionalComments = ({ invoice }) => (
  <View style={{ marginTop: 30 }}>
    {invoice.description && (
      <>
        <Text style={styles.subTitle_plain}>Additional Comments:</Text>
        <View style={{ ...styles.comment_box, border: 'none' }}>
          <Text style={styles.text}>{invoice.description}</Text>
        </View>
      </>
    )}
  </View>
);
